import React from 'react';

interface VideoPlayerHeaderProps {
    title?: string;
    onClose: () => void;
}

export const VideoPlayerHeader: React.FC<VideoPlayerHeaderProps> = ({
    title,
    onClose,
}) => {
    return (
        <div className="flex flex-col w-full max-w-[min(1500px,calc((100vh-280px)*16/9))]">
            <div className="flex items-center justify-between mb-6 flex-shrink-0">
                <h2 className="text-white-100 text-base font-medium">
                    {title || 'Video'}
                </h2>
                <button
                    onClick={onClose}
                    className="flex items-center gap-3 cursor-pointer"
                >
                    <span className="text-grey-200 text-sm">Close</span>
                    <div className="px-2 py-1 bg-grey-600 rounded text-white-100 text-xs font-geist-mono">
                        ESC
                    </div>
                </button>
            </div>
        </div>
    );
};
